import {
  useToast,
} from '@NitrexGroup/primevue/usetoast';

let toastRef: ReturnType<typeof useToast> | null = null;

export function initToast(toast: ReturnType<typeof useToast>) {
  toastRef = toast;
}

export function getToast() {
  if (!toastRef) {
    throw new Error('Toast not initialized');
  }
  return toastRef;
}
